import React, { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./popupsright.css";
import coinImage from "../images/coins.png";

const CoinButtonWithDropdown = () => {
  const btnRef = useRef(null);
  const popupRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // detect mobile / desktop
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // inchide popup la click in afara
  useEffect(() => {
    const close = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("stats-popup-open");
    } else {
      document.body.classList.remove("stats-popup-open");
    }

    return () => {
      document.body.classList.remove("stats-popup-open");
    };
  }, [open]);

  return (
    <div className="first-main-pagi-coin-wrapper">
      {/* BUTON */}
      <div
        ref={btnRef}
        className="first-main-pagi-stats-button"
        onClick={() => setOpen(!open)}
      >
        <img
          src={coinImage}
          alt="coin"
          className="first-main-pagi-stats-icon"
        />
        <div className="first-main-pagi-stats-number">0</div>
      </div>

      {open && createPortal(
        <>
          <div
            className="first-main-pagi-overlay"
            onClick={() => setOpen(false)}
          />

          <div
            ref={popupRef}
            className={`first-main-pagi-popup first-main-pagi-coin-popup ${
              isMobile ? "mobile" : "desktop"
            }`}
          >
            <div className="first-main-pagi-popup-header">
              <div className="orientation-title-popup-main">
                <img
          src={coinImage}
          alt="coin"
          className="first-main-pagi-stats-icon"
        />
              <p className="distance-coin">Sold monede</p>

              </div>
              
            </div>
            <div className="coin-balance-details">
              <div className="coin-row">
                <span>Sold precedent monede:</span>
                <span className="coin-amount">0</span>
              </div>
              <div className="coin-row">
                <span>Rulat monede:</span>
                <span className="coin-amount">0</span>
              </div>
              <div className="coin-row">
                <span>Sold final monede:</span>
                <span className="coin-amount">0</span>
              </div>
            </div>
           
            <div className="first-main-pagi-popup-item-coins">
              <span className="color-button-streak">Detalii sold</span>
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};

export default CoinButtonWithDropdown;
